// extracted by mini-css-extract-plugin
module.exports = {"section":"NumberAni_section__1808C"};